import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

// create slice
const name = "committeeAdminDashboard";
const initialState = createInitialState();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const committeeAdminDashboardActions = { ...slice.actions, ...extraActions };
export const committeeAdminDashboardReducer = slice.reducer;

function createInitialState() {
  return {
    cardCountsVisibleToCommitteeAdmin: {},
    loginStatusVisibleToCommitteeAdmin: {},
    monthlyEventsCountVisibleToCommitteeAdmin: {},
    yearlyEventsCountVisibleToCommitteeAdmin: {},
    exportCommitteeAdminEventData:{},   // Used for export specific committee events to excel
    exportCommitteeLoginStatus:{},
    loading: false,
  };
}


function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getCommitteeAdminDashboardCardCount: getCommitteeAdminDashboardCardCount(),
    getloginStatusVisibleToCommitteeAdmin: getloginStatusVisibleToCommitteeAdmin(), //Super Admin Visible Login Status
    getMonthlyEventCountByCommitteeAdmin: getMonthlyEventCountByCommitteeAdmin(),
    getYearlyEventCountByCommitteeAdmin: getYearlyEventCountByCommitteeAdmin(),
    exportCommitteeAdminEventData: exportCommitteeAdminEventData(),     // Used for export specific committee events to excel
    exportCommitteeLoginStatus: exportCommitteeLoginStatus(),
  };

  /* get all Super Admin Visible Counts (Members, Events, Category, Documents) */
  function getCommitteeAdminDashboardCardCount() {
    return createAsyncThunk(
      `${name}/getAdminDashboardCardCount`,
      async ({ id, startDate, endDate }) => {
        return await fetchWrapper.get(
          `${baseUrl}/dashboard/getAdminDashboardCardCount/${id}?startDate=${startDate}&endDate=${endDate}`
        );
      }
    );
  }


  //Super Admin Visible Login Status
  function getloginStatusVisibleToCommitteeAdmin() {
    return createAsyncThunk(`${name}/login-stats`, async ({ id, startDate, endDate }) => {
      return await fetchWrapper.get(
        // `${baseUrl}/dashboard/login-stats/month-start/68a424af22cd18137a6ba37e`
        `${baseUrl}/dashboard/login-stats/${id}?startDate=${startDate}&endDate=${endDate}`
      );
    });
  }


  // get Members count by each committee
  function getMonthlyEventCountByCommitteeAdmin() {
    return createAsyncThunk(`${name}/monthly-event-count-admin`, async ({ id, startDate, endDate }) => {
      return await fetchWrapper.get(
        `${baseUrl}/dashboard/committee/${id}/monthly-event-count?startDate=${startDate}&endDate=${endDate}`
      );
    });
  }

  // get Members count by each committee
  function getYearlyEventCountByCommitteeAdmin() {
    return createAsyncThunk(`${name}/yearly-event-count`, async ({ id, startDate, endDate }) => {
      return await fetchWrapper.get(
        `${baseUrl}/dashboard/committee/${id}/yearly-event-count?startDate=${startDate}&endDate=${endDate}`
      );
    });
  }


  // Used for export specific committee events to excel
  function exportCommitteeAdminEventData() {
    return createAsyncThunk(`${name}/exportCommitteeAdminEvents`, async ({ committee, startDate, endDate }) => {
      return await fetchWrapper.get(
         `${baseUrl}/export/committee-admin-events?committee=${committee}&startDate=${startDate}&endDate=${endDate}`
      );
    });
  }

  // Used for export specific committee events to excel
  function exportCommitteeLoginStatus() {
    return createAsyncThunk(`${name}/committee-admin-login-history`, async ({ committee, startDate, endDate }) => {
      return await fetchWrapper.get(
         `${baseUrl}/export/committee-admin-login-history?committee=${committee}&startDate=${startDate}&endDate=${endDate}`
      );
    });
  }
}

function createExtraReducers(builder) {
  builder
    //Super Admin Visible Card Counts
    .addCase(
      extraActions.getCommitteeAdminDashboardCardCount.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.getCommitteeAdminDashboardCardCount.fulfilled,
      (state, action) => {
        state.loading = false;
        state.cardCountsVisibleToCommitteeAdmin = action?.payload;
      }
    )
    .addCase(
      extraActions.getCommitteeAdminDashboardCardCount.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    //Super Admin Visible Login Status
    .addCase(
      extraActions.getloginStatusVisibleToCommitteeAdmin.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.getloginStatusVisibleToCommitteeAdmin.fulfilled,
      (state, action) => {
        state.loading = false;
        state.loginStatusVisibleToCommitteeAdmin = action?.payload;
      }
    )
    .addCase(
      extraActions.getloginStatusVisibleToCommitteeAdmin.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    //Event Count By Committee
    .addCase(
      extraActions.getMonthlyEventCountByCommitteeAdmin.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.getMonthlyEventCountByCommitteeAdmin.fulfilled,
      (state, action) => {
        state.loading = false;
        state.monthlyEventsCountVisibleToCommitteeAdmin = action?.payload?.data;
      }
    )
    .addCase(
      extraActions.getMonthlyEventCountByCommitteeAdmin.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    //Yearly Event Count By Committee
    .addCase(
      extraActions.getYearlyEventCountByCommitteeAdmin.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.getYearlyEventCountByCommitteeAdmin.fulfilled,
      (state, action) => {
        state.loading = false;
        state.yearlyEventsCountVisibleToCommitteeAdmin = action?.payload?.data;
      }
    )
    .addCase(
      extraActions.getYearlyEventCountByCommitteeAdmin.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )


    // Used for export specific committee events to excel
    .addCase(
      extraActions.exportCommitteeAdminEventData.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.exportCommitteeAdminEventData.fulfilled,
      (state, action) => {
        state.loading = false;
        state.exportCommitteeAdminEventData = action?.payload?.data;
      }
    )
    .addCase(
      extraActions.exportCommitteeAdminEventData.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )


     // Used for export specific committee events to excel
    .addCase(
      extraActions.exportCommitteeLoginStatus.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.exportCommitteeLoginStatus.fulfilled,
      (state, action) => {
        state.loading = false;
        state.exportCommitteeLoginStatus = action?.payload?.data;
      }
    )
    .addCase(
      extraActions.exportCommitteeLoginStatus.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    );

}
